<div [class]="'tile-aggregator ' + currentViewState()">
    <div class="game-tile">
        <div class="top-ten-games-wrapper">
            <div class="game-tile-children">
                <div class="gradient-container">
                    <ng-content select="[slot=gradient]"></ng-content>
                </div>
                <div
                    class="image-container"
                    (mouseenter)="mouseenter()"
                    (mouseleave)="mouseleave()"
                    [class.hovered]="currentViewState() === viewStates.Overlay">
                    <div class="game-badge" [class.fixed]="currentViewState() === viewStates.Normal">
                        <ng-content select="[slot=badge]"></ng-content>
                    </div>
                    @if (withFav() && (!withOverlay() || currentViewState() === viewStates.Overlay)) {
                        <div class="positioned-fav-cta">
                            <ng-content select="[slot=gametileFavCta]"></ng-content>
                        </div>
                    }
                    <ng-content select="[slot=freespinsSummaryIcon]"></ng-content>
                    <ng-content select="[slot=imageLoader]"></ng-content>
                    @if (currentViewState() === viewStates.Normal) {
                        <div class="positioned-jackpot-ribbon" [class.fixed]="currentViewState() === viewStates.Overlay">
                            <ng-content select="[slot=jackpotHotIcon]"></ng-content>
                        </div>
                    }
                    <div class="positioned-mobile-i-icon">
                        <ng-content select="[slot=quickInfoIcon]"></ng-content>
                    </div>
                    @if (withOverlay()) {
                        <div class="overlay-container" [class.view-state-disabled]="currentViewState() === viewStates.Disabled">
                            <div [class.overlay-bg]="currentViewState() !== viewStates.Disabled"></div>
                            <div [class.overlay-buttons]="currentViewState() !== viewStates.Disabled">
                                <ng-content select="[slot=gameTileCta]"></ng-content>
                                <ng-content select="[slot=hyperlinkCta]"></ng-content>
                            </div>
                        </div>
                    }
                </div>
            </div>
            <div class="game-tile-children">
                <div class="gradient-container"></div>
                <ng-content select="[slot=gameTileFooter]"></ng-content>
            </div>
        </div>
    </div>
</div>
